export const date = [
  { key: "最近一个月", value: "one_month" },
  { key: "最近三个月", value: "three_month" },
  { key: "最近半年", value: "six_month" },
  /*{ key: "2018年", value: "2018" },
  { key: "2017年", value: "2017" },
  { key: "2016年", value: "2016" }*/
];

export const manager_status = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

export const manager_status_system = [
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" }
];

export const class_manager_status = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "培训班已完成", value: "Complete" }
];

export const class_score_status = [
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" }
];

export const user_status = [
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

// 十一人制等级讲师级别列表
export const teacher_level = [
  { key: "职业级", value: "0" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
  { key: "D级助理", value: "E" },
];

// 五人制等级讲师
export const teacher_level_five = [
  { key: '初级助理', value: 'early_assistant' },
  { key: '初级', value: 'early' },
  { key: 'L1级', value: 'L1' },
  { key: 'L2级', value: 'L2' },
  { key: 'L3级', value: 'L3' },
]

// 十一人制守门员讲师列表
export const teacher_level_goalkeeper = [
  { key: '守门员A级', value: 'GA', },
  { key: '守门员B级', value: 'GB', },
  { key: '守门员C级', value: 'GC', },
  { key: '守门员C级助理', value: 'GD', },
]

// 十一人制体能讲师列表
export const teacher_level_physical = [
  { key: '体能L2级', value: 'F2', },
  { key: '体能L1级', value: 'F1', },
  { key: '体能L1级助理', value: 'F0', },
]

export const tutorial_types = [
  { key: "全部教案", value: "" },
  { key: "实践教案", value: "practice" },
  { key: "考试教案", value: "exam" },
];

export const evaStatus = [
  { key: "未调查", value: "N" },
  { key: "已调查", value: "Y" },
];

export const levelName = {
  // 十一人制培训班
  "A": "A级教练员培训班",
  "B": "B级教练员培训班",
  "C": "C级教练员培训班",
  "D": "D级教练员培训班",
  "PRO":"职业级教练员培训班",
  //  十一人制 守门员教练
  "GC": "守门员C级教练培训班",
  "GB": "守门员B级教练培训班",
  "GA": "守门员C级教练培训班",

  // 五人制培训班
  "early": "五人制初级培训班",
  "L1": "五人制L1级培训班",
  "L2": "五人制L2级培训班",
  "L3": "五人制L3级培训班",

};
// 培训班等级
export const ClassLevelHashDict = {
  //  十一人制
  "A": "A",
  "B": "B",
  "C": "C",
  "D": "D",
  //  十一人制守门员教练 - 暂时未作处理
  // "GC": "守门员C级",
  // "GB": "守门员B级",
  // "GA": "守门员A级",

  // 五人制
  "early": "初",
  "L1": "L1",
  "L2": "L2",
  "L3": "L3",
};
export const levelNameTeacher = {
  "A": "A级讲师继续教育培训班",
  "B": "B级讲师继续教育培训班",
  "C": "C级讲师继续教育培训班",
  "D": "D级讲师继续教育培训班",
  "E": "D级助理讲师继续教育培训班",
};



export const levelOptions = [
  /*{
    val: "A",
    text: "A级"
  },
  {
    val: "B",
    text: "B级"
  },*/
  {
    val: "E",
    text: "D级助理"
  },
  {
    val: "D",
    text: "D级"
  },
  {
    val: "C",
    text: "C级"
  },
];

export const highClassLevelList = [
  { key: "C级", value: "C" },
  { key: "B级", value: "B" },
  { key: "A级", value: "A" },
  { key: "职业级", value: "PRO" },
];

// 十一人制培训班等级
export const classLevelList = [
  { key: "D级助理", value: "E" },
  { key: "D级", value: "D" },
  { key: "C级", value: "C" },
  { key: "B级", value: "B" },
  { key: "A级", value: "A" },
  { key: "职业级", value: "PRO" },
];
// 十一人制培训班等级 扩充守门员教案等级 （教案筛选用）
export const classLevelListForGoalkeeper = [
  { key: "守门员C级", value: "GC" },
  { key: "守门员B级", value: "GB" },
  { key: "守门员A级", value: "GA" },
]
// 十一人制培训班等级 扩充体能教案等级 （教案筛选用）
export const classLevelListForPhysical = [
  { key: "体能L1级", value: "F1" },
  { key: "体能L2级", value: "F2" },
]
export const classLevelListForGoalkeeperWithLangKey = [
  { key: "守门员C级教练", value: "GC" },
  { key: "守门员B级教练", value: "GB" },
  { key: "守门员A级教练", value: "GA" },
]

export const classLevelListForPhysicalWithLangKey = [
  { key: "体能L1级教练", value: "F1" },
  { key: "体能L2级教练", value: "F2" },
]

// 五人制培训班等级
export const classLevelListFive = [
  { key: '初级', value: 'early' },
   { key: 'L1级', value: 'L1' },
   { key: 'L2级', value: 'L2' },
   { key: 'L3级', value: 'L3' },
]

// 五人制培训班等级 低级别
export const classLevelListFiveLow = [
  { key: '初级', value: 'early' },
   { key: 'L1级', value: 'L1' },
]

export const enrollStatus = [
  { key: "暂时保存", value: "enrollEdit" },
  { key: "报名未开始", value: "enrollInitiated" },
  { key: "报名进行中", value: "enrollIncomplete" },
  { key: "报名已结束", value: "enrollFinalised" },
  { key: "报名已完成", value: "enrollComplete" },
  { key: "报名已关闭", value: "enrollClose" },
];
export const HidgClassStatus = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

export const personnelStatus = [
  { key: "会员协会拒绝", value: "personnelRefused" },
  { key: "会员协会推荐", value: "personnelThrough" },
  { key: "会员协会通过", value: "organThrough" },
  { key: "会员协会审核中", value: "personnelSubmitted" },
  { key: "报名审核拒绝", value: "enrollCheckRefused" },
  { key: "报名审核通过", value: "enrollCheckThrough" },
  // { key: "中国足协已录取", value: "personnelAdmit" },
  // { key: "中国足协未录取", value: "personnelUnadmit" },

];
export const personnelExamStatus = [
  // { key: "中国足协已录取", value: "personnelAdmit" },
  // { key: "中国足协未录取", value: "personnelUnadmit" },
  { key: "补考申请待处理", value: "examPersonnel" },
  { key: "补考审核拒绝", value: "examRefused" },
  { key: "补考审核通过", value: "examThrough" },
];
// 专项培训讲师级别
export const proLevellist = [
  { key: '无', value: '' },
  { key: "亚足联体能讲师", value: 'stamina' },
  { key: "亚足联守门员讲师", value: "goaltender" }
];

// 教练员级别
export const colLevellist = [
  { key: "亚足联/中国足协职业级教练员", value: "0" },
  { key: "亚足联/中国足协A级教练员", value: "A" },
  { key: "亚足联/中国足协B级教练员", value: "B" },
  { key: "中国足协C级教练员", value: "C" },
  { key: "中国足协D级教练员", value: "D" },
  { key: "亚足联守门员教练L1", value: 'G-L1' },
  { key: "亚足联守门员教练L2", value: 'G-L2' },
  { key: "亚足联守门员教练L3", value: 'G-L3' },
  { key: "亚足联体能教练L1", value: 'S-L1' },
  { key: "亚足联体能教练L2", value: 'S-L2' }
];
// 教练员级别 - 五人制
export const colLevellistFive = [
  { key: "亚足联/中国足协五人制L3级教练员", value: 'L3' },
  { key: "亚足联/中国足协五人制L2级教练员", value: 'L2' },
  { key: "亚足联/中国足协五人制L1级教练员", value: 'L1' },
  { key: "中国足协五人制初级教练员", value: 'early' },
  { key: "亚足联五人制守门员教练L1", value: 'GF-L1' },
  { key: "亚足联五人制守门员教练L2", value: 'GF-L2' },
  { key: "亚足联五人制守门员教练L3", value: 'GF-L3' },
  { key: "亚足联五人制体能教练L1", value: 'SF-L1' },
  { key: "亚足联五人制体能教练L2", value: 'SF-L2' },
]

export const qualificationList = [
  { key: '小学', value: '小学' },
  { key: '初中', value: '初中' },
  { key: '高中', value: '高中' },
  { key: '职专', value: '职专' },
  { key: '大专', value: '大专' },
  { key: '本科', value: '本科' },
  { key: '硕士', value: '硕士' },
  { key: '博士', value: '博士' },
];

export const teamList = [
  { key: '国家队', value: '国家队' },
  { key: '青少年国家队', value: '青少年国家队' },
  { key: '顶级联赛', value: '顶级联赛' },
  { key: '第二级别联赛', value: '第二级别联赛' },
  { key: '第三级别联赛', value: '第三级别联赛' },
  { key: '全国性业余联赛', value: '全国性业余联赛' },
  { key: '地方性业余联赛', value: '地方性业余联赛' },
  { key: '全运会', value: '全运会' },
  { key: '职业俱乐部精英青少年', value: '职业俱乐部精英青少年' },
  { key: '地方协会青少年', value: '地方协会青少年' },
  { key: '校园足球', value: '校园足球' },
  { key: '其他', value: '其他' },
  // { key: '省市足协队伍', value: '省市足协队伍' },
  // { key: '校园足球队伍（小/初/高、大专院校校队和院队）', value: '校园足球队伍（小/初/高、大专院校校队和院队）' },
  // { key: '国少', value: '国少' },
  // { key: '国青', value: '国青' },
  // { key: '国奥', value: '国奥' },
];

export const tea_level = [
  { key: "亚足联/中国足协职业级讲师", value: "0" },
  { key: "亚足联/中国足协A级讲师", value: "A" },
  { key: "亚足联/中国足协B级讲师", value: "B" },
  { key: "中国足协C级讲师", value: "C" },
  { key: "中国足协D级讲师", value: "D" },
  { key: "中国足协D级助教", value: "E" },
];

export const tea_level_five = [
  { key: "亚足联/中国足协L3级讲师", value: "L3" },
  { key: "亚足联/中国足协L2级讲师", value: "L2" },
  { key: "亚足联/中国足协L1级讲师", value: "L1" },
  { key: "中国足协初级讲师", value: "early" },
  { key: "中国足协初级助理", value: "early_assistant" },
]

export const enroll_type_list = [
  { key: "教练员等级培训报名（十一人制）", value: "common", disabled: false },
  { key: "体能教练员培训报名（十一人制）", value: "physical_train", disabled: false },
  { key: "守门员教练员培训报名（十一人制）", value: "goalkeeper_train", disabled: false },
  { key: "教练员等级培训补考报名（十一人制）", value: "make_up_exam", disabled: false },
  { key: "体能教练员补考报名（十一人制）", value: "physical_make_up_exam", disabled: false },
  { key: "教练员继续教育培训（十一人制）", value: "continue_education", disabled: true },
  { key: "讲师继续教育培训报名（十一人制）", value: "teacher_train", disabled: false },
  { key: "守门员教练继续教育培训报名（十一人制）", value: "goalkeeper_education", disabled: false },
];

// 十一人制培训班类型
export const class_train_type_list = [
  { key: "教练员等级培训（十一人制）", value: "train", disabled: false },
  { key: "体能教练员等级培训（十一人制）", value: "physical_train", disabled: false },
  { key: "守门员教练等级培训（十一人制）", value: "goalkeeper_train", disabled: false },
  { key: "教练员继续教育培训（十一人制线下）", value: "continue_education", disabled: true },
  { key: "讲师继续教育培训（十一人制）", value: "teacher_train", disabled: false },
  { key: "守门员教练继续教育培训（十一人制）", value: "goalkeeper_education", disabled: false },
];

// 五人制培训班类型
export const class_train_type_list_five = [
  { key: "教练员等级培训（五人制）", value: "train", disabled: true },
]


export const enroll_type_list_org = [
  { key: "教练员等级培训报名（十一人制）", value: "common" },
  { key: "体能教练员培训报名（十一人制）", value: "physical_train" },
  { key: "守门员教练员培训报名（十一人制）", value: "goalkeeper_train" },
  { key: "教练员继续教育培训（十一人制线下）", value: "continue_education" },
  { key: "守门员教练继续教育培训（十一人制）", value: "goalkeeper_education" },
  // { key: '守门员教练继续教育报名', name: '守门员教练继续教育报名', value: 'goalkeeper_education', },
];

export const quaLevelList = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
];
export const quaLevelListAll = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
  { key: "岗位培训初级", value: "初" },
  { key: "岗位培训中级", value: "中" },
  { key: "岗位培训高级", value: "高" },
  { key: "职业级继续教育", value: "P(继)" },
  { key: "A级继续教育", value: "A(继)" },
  { key: "B级继续教育", value: "B(继)" },
  { key: "C级继续教育", value: "C(继)" },
  { key: "国际教练员资质认证(职业级)", value: "P(国际)" },
  { key: "国际教练员资质认证(A级)", value: "A(国际)" },
  { key: "国际教练员资质认证(B级)", value: "B(国际)" },
  { key: "国际教练员资质认证(C级)", value: "C(国际)" },
];

export const train_type_list = [
  { key: "等级培训", value: "level" },
  { key: "岗位培训", value: "job" },
  { key: "继续教育", value: "education" },
  { key: "国际教练员资质认证", value: "international" },
  
];
export const futsal_train_type_list = [
  { key: "五人制等级教练员培训", value: "futsal_level" },
]
export const job_list = [
  { key: "初级", value: "初" },
  { key: "中级", value: "中" },
  { key: "高级", value: "高" },
];
export const audit_edu_list = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
];
export const international_list = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
];
export const futsal_list = [
  { key: "足球初级教练员", value: "初" },
  { key: "足球L1级教练员", value: "L1" },
  { key: "足球L2级教练员", value: "L2" },
  { key: "足球L3级教练员", value: "L3" },
  { key: "足球职业级教练员", value: "P" },
];

export const punish_type_list = [
  { label: '培训处罚', value: 'fakes' },
  { label: '纪律处罚', value: 'punish' },
  { label: '其他', value: 'other' },
]
export const punish_status_list = [
  { label: '封禁中', value: '0' },
  { label: '撤销', value: '1' },
  { label: '已解禁', value: '2' },
]
export const licenseWaitList = [
  { key: "职业级", value: "0" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
];

export const genderList = [
  { key: '女', val: '女' },
  { key: '男', val: '男' },
];

export const licenseDistributeWay = [
  { key: '邮寄或自取', val: 'invite_or_mail' },
  { key: '邮寄', val: 'mail' },
  { key: '自取', val: 'invite' },
];

// 培训地区
export const trainingRegionList = [
  { key: '中国大陆', value: 'territory_of_China' },
  { key: '港澳台', value: 'HMT' },
  { key: '其他', value: 'other' },
];

// 证件类型
export const id_types = [
  { key: "中国居民身份证", value: "id_number" },
  { key: "外国人永久居留身份证", value: "idTypeCode_wgjzz" },
  { key: "港澳台居民居住证", value: "idTypeCode_HMT" },
  { key: "港澳居民来往内地通行证", value: "HM" },
  { key: "台湾居民来往大陆通行证", value: "TAI" },
  { key: "护照（仅国外教练员使用）", value: "passport" }
];
// 执教经历
export const coach_experience = [{
  value: '男队',
  label: '男队',
  children: [{
    value: '国家队执教经历',
    label: '国家队执教经历',
    children: [{
      value: '中国国家男子足球队',
      label: '中国国家男子足球队'
    }, {
      value: '中国奥林匹克男子足球队',
      label: '中国奥林匹克男子足球队'
    }, {
      value: '中国国家青年男子足球队',
      label: '中国国家青年男子足球队'
    }, {
      value: '中国国家少年男子足球队',
      label: '中国国家少年男子足球队'
    }, {
      value: '其他U系列男子国家队',
      label: '其他U系列男子国家队'
    }, {
      value: '中国国家男子五人制足球队',
      label: '中国国家男子五人制足球队'
    }, {
      value: '中国国家男子U-20五人制足球国家队',
      label: '中国国家男子U-20五人制足球国家队'
    }, {
      value: '中国国家男子沙滩足球队',
      label: '中国国家男子沙滩足球队'
    }]
  }, {
    value: '职业俱乐部一队执教经历',
    label: '职业俱乐部一队执教经历',
    children: [{
      value: '中超（甲A）',
      label: '中超（甲A）'
    }, {
      value: '中甲（甲B）',
      label: '中甲（甲B）'
    }, {
      value: '中乙',
      label: '中乙'
    }, {
      value: '五超',
      label: '五超'
    }, {
      value: '五甲',
      label: '五甲'
    }]
  }, {
    value: '职业俱乐部梯队、预备队执教经历',
    label: '职业俱乐部梯队、预备队执教经历',
    children: [{
      value: '中超（甲A）',
      label: '中超（甲A）'
    }, {
      value: '中甲（甲B）',
      label: '中甲（甲B）'
    }, {
      value: '中乙',
      label: '中乙'
    }, {
      value: '五超',
      label: '五超'
    }, {
      value: '五甲',
      label: '五甲'
    }]
  }, {
    value: '业余俱乐部执教经历',
    label: '业余俱乐部执教经历',
    children: [{
      value: '中冠俱乐部',
      label: '中冠俱乐部'
    }, {
      value: '其他社会业余俱乐部',
      label: '其他社会业余俱乐部'
    }, {
      value: '社会青训机构',
      label: '社会青训机构'
    }]
  }, {
    value: '校园足球执教经历',
    label: '校园足球执教经历',
    children: [{
      value: '小学校队',
      label: '小学校队'
    }, {
      value: '中学校队',
      label: '中学校队'
    }, {
      value: '高中校队',
      label: '高中校队'
    }, {
      value: '大专院校院队',
      label: '大专院校院队'
    }, {
      value: '大专院校校队',
      label: '大专院校校队'
    }]
  }, {
    value: '省市体育局、足协队伍执教经历',
    label: '省市体育局、足协队伍执教经历',
    children: [{
      value: '省市体育局、足协队伍',
      label: '省市体育局、足协队伍'
    }]
  }]
}, {
  value: '女队',
  label: '女队',
  children: [{
    value: '国家队执教经历',
    label: '国家队执教经历',
    children: [{
      value: '中国国家女子足球队',
      label: '中国国家女子足球队'
    }, {
      value: '中国国家青年女子足球队',
      label: '中国国家青年女子足球队'
    }, {
      value: '中国国家少年女子足球队',
      label: '中国国家少年女子足球队'
    }, {
      value: '其他U系列女子国家队',
      label: '其他U系列女子国家队'
    }, {
      value: '中国国家女子五人制足球队',
      label: '中国国家女子五人制足球队'
    }]
  }, {
    value: '职业俱乐部执教经历',
    label: '职业俱乐部执教经历',
    children: [{
      value: '女超',
      label: '女超'
    }, {
      value: '女甲',
      label: '女甲'
    }, {
      value: '女乙',
      label: '女乙'
    }, {
      value: '五女',
      label: '五女'
    }]
  }, {
    value: '校园足球执教经历',
    label: '校园足球执教经历',
    children: [{
      value: '小学校队',
      label: '小学校队'
    }, {
      value: '中学校队',
      label: '中学校队'
    }, {
      value: '高中校队',
      label: '高中校队'
    }, {
      value: '大专院校院队',
      label: '大专院校院队'
    }, {
      value: '大专院校校队',
      label: '大专院校校队'
    }]
  }, {
    value: '省市体育局、足协队伍执教经历',
    label: '省市体育局、足协队伍执教经历',
    children: [{
      value: '省市体育局、足协队伍',
      label: '省市体育局、足协队伍'
    }]
  }, {
    value: '社会业余俱乐部执教经历',
    label: '社会业余俱乐部执教经历',
    children: [{
      value: '社会业余俱乐部',
      label: '社会业余俱乐部'
    }, {
      value: '社会青训机构',
      label: '社会青训机构'
    }]
  }]
}];
// 执教场所
export const take_place = [{
  value: '职业俱乐部一队',
  label: '职业俱乐部一队',
  children: [{
    value: '中超',
    label: '中超'
  }, {
    value: '中甲',
    label: '中甲'
  }, {
    value: '中乙',
    label: '中乙'
  }, {
    value: '女超',
    label: '女超'
  }, {
    value: '女甲',
    label: '女甲'
  }, {
    value: '女乙',
    label: '女乙'
  }, {
    value: '五超',
    label: '五超'
  }, {
    value: '五甲',
    label: '五甲'
  }, {
    value: '五女',
    label: '五女'
  }]
}, {
  value: '职业俱乐部梯队',
  label: '职业俱乐部梯队',
  children: [{
    value: '中超',
    label: '中超'
  }, {
    value: '中甲',
    label: '中甲'
  }, {
    value: '中乙',
    label: '中乙'
  }, {
    value: '五超',
    label: '五超'
  }, {
    value: '五甲',
    label: '五甲'
  }]
}, {
  value: '体育局、足协训练基地',
  label: '体育局、足协训练基地',
  children: [{
    value: '体育局、足协训练基地',
    label: '体育局、足协训练基地'
  }]
}, {
  value: '学校',
  label: '学校',
  children: [{
    value: '小学',
    label: '小学'
  }, {
    value: '初中',
    label: '初中'
  }, {
    value: '高中',
    label: '高中'
  }, {
    value: '大专院校',
    label: '大专院校'
  }]
}, {
  value: '业余俱乐部社会训练场地',
  label: '业余俱乐部社会训练场地',
  children: [{
    value: '中冠俱乐部',
    label: '中冠俱乐部'
  }, {
    value: '其他社会业余俱乐部',
    label: '其他社会业余俱乐部'
  }, {
    value: '社会青训机构',
    label: '社会青训机构'
  }]
}, {
  value: '其他场所',
  label: '其他场所',
  children: [{
    value: '其他场所',
    label: '其他场所'
  }]
}];

// 运动经历 男
export const sport_experience_male = [{
  value: '国家队运动经历',
  label: '国家队运动经历',
  children: [{
    value: '中国国家男子足球队',
    label: '中国国家男子足球队'
  }, {
    value: '中国奥林匹克男子足球队',
    label: '中国奥林匹克男子足球队'
  }, {
    value: '中国国家青年男子足球队',
    label: '中国国家青年男子足球队'
  }, {
    value: '中国国家少年男子足球队',
    label: '中国国家少年男子足球队'
  }, {
    value: '其他U系列男子国家队',
    label: '其他U系列男子国家队'
  }, {
    value: '中国国家男子五人制足球队',
    label: '中国国家男子五人制足球队'
  }, {
    value: '中国国家男子U-20五人制足球国家队',
    label: '中国国家男子U-20五人制足球国家队'
  }, {
    value: '中国国家男子沙滩足球队',
    label: '中国国家男子沙滩足球队'
  }]
}, {
  value: '职业俱乐部一队运动经历',
  label: '职业俱乐部一队运动经历',
  children: [{
    value: '中超（甲A）',
    label: '中超（甲A）'
  }, {
    value: '中甲（甲B）',
    label: '中甲（甲B）'
  }, {
    value: '中乙',
    label: '中乙'
  }, {
    value: '五超',
    label: '五超'
  }, {
    value: '五甲',
    label: '五甲'
  }]
}, {
  value: '职业俱乐部梯队、预备队运动经历',
  label: '职业俱乐部梯队、预备队运动经历',
  children: [{
    value: '中超（甲A）',
    label: '中超（甲A）'
  }, {
    value: '中甲（甲B）',
    label: '中甲（甲B）'
  }, {
    value: '中乙',
    label: '中乙'
  }, {
    value: '五超',
    label: '五超'
  }, {
    value: '五甲',
    label: '五甲'
  }]
}, {
  value: '业余俱乐部运动经历',
  label: '业余俱乐部运动经历',
  children: [{
    value: '中冠俱乐部',
    label: '中冠俱乐部'
  }, {
    value: '其他社会业余俱乐部',
    label: '其他社会业余俱乐部'
  }]
}, {
  value: '校园足球运动经历',
  label: '校园足球运动经历',
  children: [{
    value: '小学校队',
    label: '小学校队'
  }, {
    value: '中学校队',
    label: '中学校队'
  }, {
    value: '高中校队',
    label: '高中校队'
  }, {
    value: '大专院校院队',
    label: '大专院校院队'
  }, {
    value: '大专院校校队',
    label: '大专院校校队'
  }]
}, {
  value: '省市体育局、足协队伍运动经历',
  label: '省市体育局、足协队伍运动经历',
  children: [{
    value: '省市体育局、足协队伍',
    label: '省市体育局、足协队伍'
  }]
}];

// 运动经历 女
export const sport_experience_Female = [{
  value: '国家队运动经历',
  label: '国家队运动经历',
  children: [{
    value: '中国国家女子足球队',
    label: '中国国家女子足球队'
  }, {
    value: '中国国家青年女子足球队',
    label: '中国国家青年女子足球队'
  }, {
    value: '中国国家少年女子足球队',
    label: '中国国家少年女子足球队'
  }, {
    value: '其他U系列女子国家队',
    label: '其他U系列女子国家队'
  }, {
    value: '中国国家女子五人制足球队',
    label: '中国国家女子五人制足球队'
  }]
}, {
  value: '职业俱乐部运动经历',
  label: '职业俱乐部运动经历',
  children: [{
    value: '女超',
    label: '女超'
  }, {
    value: '女甲',
    label: '女甲'
  }, {
    value: '女乙',
    label: '女乙'
  }, {
    value: '五女',
    label: '五女'
  }]
}, {
  value: '校园足球运动经历',
  label: '校园足球运动经历',
  children: [{
    value: '小学校队',
    label: '小学校队'
  }, {
    value: '中学校队',
    label: '中学校队'
  }, {
    value: '高中校队',
    label: '高中校队'
  }, {
    value: '大专院校院队',
    label: '大专院校院队'
  }, {
    value: '大专院校校队',
    label: '大专院校校队'
  }]
}, {
  value: '省市体育局、足协队伍运动经历',
  label: '省市体育局、足协队伍运动经历',
  children: [{
    value: '省市体育局、足协队伍',
    label: '省市体育局、足协队伍'
  }]
}, {
  value: '业余俱乐部运动经历',
  label: '业余俱乐部运动经历',
  children: [{
    value: '业余俱乐部',
    label: '业余俱乐部'
  }]
}];


// 资质审查报名 - 继续教育
export const education_level_list = [
  { label: '亚足联/中国足协C级', value: 'C' },
  { label: '亚足联/中国足协B级', value: 'B' },
  { label: '亚足联/中国足协A级', value: 'A' },
  { label: '亚足联/中国足协职业级', value: 'PRO' },
]

// 资质审查报名 - 等级培训
export const train_level_list = [
  // { label: '亚足联/中国足协B级', value: 'B' },
  { label: '亚足联/中国足协A级', value: 'A' },
  // { label: '亚足联/中国足协职业级', value: 'PRO' },
]

// 十一人制机构可创建培训班等级列表
export const org_create_class_avaible = [
  {
    label: "D",
    name: "D级培训班"
  },
  {
    label: "C",
    name: "C级培训班"
  }
]
// 五人制机构可创建培训班等级列表
export const org_create_class_avaible_five = [
  {
    label: "early",
    name: "初级"
  },
  {
    label: "L1",
    name: "L1级"
  },
]


/* 教练员 报名用 守门员 等级列表 注意：下面这个列表的顺序绝对不允许调整 2023.04.23修改 守门员C 不需要继续教育了*/
export const classLevelListForCoachAndGoalkepper = [
  { key: "D级助理", name: "D级助理", value: "E", disabled: false, typeList: ['teacher_train', ], },
  { key: "D级", name: "D级", value: "D", disabled: false, typeList: ['continue_education','teacher_train',], },
  { key: "C级", name: "C级", value: "C", disabled: false, typeList: ['continue_education','teacher_train', ], },
  { key: "B级", name: "B级", value: "B", disabled: false, typeList: ['continue_education', 'common', 'make_up_exam','teacher_train', ], },
  { key: "A级", name: "A级", value: "A", disabled: false, typeList: ['continue_education', 'common', 'make_up_exam', 'teacher_train',], },
  { key: "职业级", name: "职业级", value: "PRO", disabled: false, typeList: ['continue_education',  'common', 'make_up_exam', 'teacher_train',], },
  { key: "守门员C级", name: "守门员C级", value: "GC", disabled: false, typeList: ['goalkeeper_train' ], },
  { key: "守门员B级", name: "守门员B级", value: "GB", disabled: false, typeList: ['goalkeeper_train','goalkeeper_education', ], },
  { key: "守门员A级", name: "守门员A级", value: "GA", disabled: false, typeList: ['goalkeeper_train','goalkeeper_education', ], },
  { key: "体能L1级", name: "体能L1级", value: "F1", disabled: false, typeList: ['physical_train', 'physical_make_up_exam' ], },
  { key: "体能L2级", name: "体能L2级", value: "F2", disabled: false, typeList: ['physical_train' ], },
]


/* 教练员 报名用 守门员 等级列表 注意：下面这个列表的顺序绝对不允许调整 执照等级 2023.04.23修改 守门员C 不需要继续教育了*/
export const classLevelListForCoachAndGoalkepperForLicense = [
  { key: "D级助理", name: "D级助理", value: "E", disabled: false, typeList: ['teacher_train', ], },
  { key: "D级", name: "D级", value: "D", disabled: false, typeList: ['continue_education','teacher_train',], },
  { key: "C级", name: "C级", value: "C", disabled: false, typeList: ['continue_education','teacher_train', ], },
  { key: "B级", name: "B级", value: "B", disabled: false, typeList: ['continue_education', 'common', 'make_up_exam','teacher_train', ], },
  { key: "A级", name: "A级", value: "A", disabled: false, typeList: ['continue_education', 'common', 'make_up_exam', 'teacher_train',], },
  { key: "职业级", name: "职业级", value: "0", disabled: false, typeList: ['continue_education',  'common', 'make_up_exam', 'teacher_train',], },
  { key: "守门员C级", name: "守门员C级", value: "GC", disabled: false, typeList: ['goalkeeper_train' ], },
  { key: "守门员B级", name: "守门员B级", value: "GB", disabled: false, typeList: ['goalkeeper_train','goalkeeper_education', ], },
  { key: "守门员A级", name: "守门员A级", value: "GA", disabled: false, typeList: ['goalkeeper_train','goalkeeper_education',], },
  { key: "体能L1级", name: "体能L1级", value: "F1", disabled: false, typeList: ['physical_train', ], },
  { key: "体能L2级", name: "体能L2级", value: "F2", disabled: false, typeList: ['physical_train', ], },
]

/* 十一人制守门员教练等级 */
export const classLevelListForGoalkeeperOnly = [
  { key: "守门员C级教练", name: "守门员C级教练", value: "GC", disabled: false, typeList: ['goalkeeper_education', ], },
  { key: "守门员B级教练", name: "守门员B级教练", value: "GB", disabled: false, typeList: ['goalkeeper_education', ], },
  { key: "守门员A级教练", name: "守门员A级教练", value: "GA", disabled: false, typeList: ['goalkeeper_education', ], },
]
/* 十一人制体能教练等级 */
export const classLevelListForPhysicalOnly = [
  { key: "体能L1级教练", name: "体能L1级教练", value: "F1", disabled: false, typeList: ['physical_train', ], },
  { key: "体能L2级教练", name: "体能L2级教练", value: "F2", disabled: false, typeList: ['physical_train', ], },
]

/* 创建高级培训班用等级列表 */
export const createHeighClassLevelList = [
  { key: 'D级助理', name: 'D级助理', value: 'E', typeList: ['teacher_train',], },
  { key: 'D级', name: 'D级', value: 'D', typeList: ['continue_education','teacher_train',], },
  { key: 'C级', name: 'C级', value: 'C', typeList: ['continue_education', 'teacher_train',], },
  { key: 'B级', name: 'B级', value: 'B', typeList: ['continue_education', 'teacher_train', 'train', ], },
  { key: 'A级', name: 'A级', value: 'A', typeList: ['continue_education', 'teacher_train', 'train', ], },
   { key: '职业级', name: '职业级', value: 'PRO', typeList: ['continue_education','train'], },
  { key: '守门员C级', name: '守门员C级', value: 'GC', typeList: ['goalkeeper_train' ], },
  { key: '守门员B级', name: '守门员B级', value: 'GB', typeList: ['goalkeeper_train','goalkeeper_education', ], },
  { key: '守门员A级', name: '守门员A级', value: 'GA', typeList: ['goalkeeper_train','goalkeeper_education', ], },
  { key: '体能L1级', name: '体能L1级', value: 'F1', typeList: ['physical_train', ], },
  { key: '体能L2级', name: '体能L2级', value: 'F2', typeList: ['physical_train', ], },
]

/* 创建高级培训班用等级列表 */
export const createHeighClassLevelListFive = [
  { key: 'L2级', name: 'L2级', value: 'L2', typeList: ['train',], },
  { key: 'L3级', name: 'L3级', value: 'L3', typeList: ['train',], },
]

/* 学员高端教练员培训及补考报名筛选 */
export const heighSignUpSelectList = [
  { key: '培训报名', name: '培训报名', value: 'common', },
  { key: '补考报名', name: '补考报名', value: 'make_up_exam', },
]

/* 学员高端教练员培训及补考报名筛选 */
export const heighSignUpSelectListEducation = [
  { key: '继续教育报名', name: '继续教育报名', value: 'continue_education', },
  { key: '守门员继续教育报名', name: '守门员继续教育报名', value: 'goalkeeper_education', },
]

/* 学员高端教练员培训及补考报名筛选 */
export const heighSignUpSelectListZhuanxiang = [
  { key: '体能教练员培训报名', name: '体能教练员培训报名', value: 'physical_train', },
  { key: '体能教练员培训报名', name: '体能教练员补考报名', value: 'physical_make_up_exam', },
  { key: '守门员教练员培训报名', name: '守门员教练员培训报名', value: 'goalkeeper_train', },
]


/* 十一人制执照类型 license_type */
export const licenseTypeList = [
  { key: '等级教练执照', name: '等级教练执照', value: 'train' },
  { key: '守门员教练执照', name: '守门员教练执照', value: 'goalkeeper' },
  { key: '体能教练执照', name: '守门员教练执照', value: 'physical' },
]

export const goalkeeperName = {
  "GC": '守门员C级教练培训班',
  "GB": '守门员B级教练培训班',
  "GA": '守门员C级教练培训班',
}

export const physicalName = {
  "F1": '体能L1级教练培训班',
  "F2": '体能L2级教练培训班',
}

export const trafficWays = [
  { key: '步行', value: '步行', },
  { key: '包车', value: '包车', },
  { key: '骑行', value: '骑行', },
  { key: '驾车', value: '驾车', },
  { key: '公交', value: '公交', },
  { key: '地铁', value: '地铁', },
  { key: '其他', value: '其他', },
]

export const ageList = [
  { key: 'U13', value: 'U13' },
  { key: 'U14', value: 'U14' },
  { key: 'U15', value: 'U15' },
  { key: 'U16', value: 'U16' },
  { key: 'U17', value: 'U17' },
  { key: 'U18', value: 'U18' },
  { key: 'U19', value: 'U19' },
  { key: 'U20', value: 'U20' },
  { key: 'U21', value: 'U21' },
]

// 管理员拟报名录取状态
export const selectListForSignStu = [
  // { key: '未选择关注度', value: 'none_star' },
  { key: '一星', value: 'one_star' },
  { key: '二星', value: 'two_star' },
  { key: '三星', value: 'three_star' },
]

// 教练员转出协会申请状态(申请状态)
export const selectAlterOrgStatus = [
  // { key: 'Edit', value: '暂时保存', },
  { key: 'Initiated', value: '未开始', },
  { key: 'CoachSubmit', value: '教练员申请进行中', },
  { key: 'Finish', value: '注册窗口已结束', },
  { key: 'Complete', value: '注册已完成', },
]

// 教练员转会申请 申请状态
export const alterationCoachStatusEnter = [
  { key: 'LeaveOrgAudit', value: '转出协会审核中', },
  { key: 'LeaveOrgFail', value: '转出协会拒绝', },
//   { key: 'Finish', value: '注册变更中', },
  { key: 'Complete', value: '注册变更成功', },
]
// 教练员转会申请 申请状态
export const alterationCoachStatusLeave = [
  { key: 'EnterOrgAudit', value: '转入协会审核中', },
  { key: 'EnterOrgFail', value: '转入协会拒绝', },
  { key: 'LeaveOrgAudit', value: '转出协会审核中', },
  { key: 'LeaveOrgFail', value: '转出协会拒绝', },
//   { key: 'Finish', value: '注册变更中', },
  { key: 'Complete', value: '注册变更成功', },
]
// 管理员 培训班开班申请状态
export const classApplicationStatus = [
  { key: '开班申请审核中', value: 'audit' },
  { key: '开班申请已拒绝', value: 'refused' },
  { key: '开班申请已通过', value: 'though' },
  { key: '开班申请已完成', value: 'complete' },

]
// 管理员 继续教育状态
export const educationStatus = [
  { key: '未提交', value: 'Edit' },
  { key: '未开始', value: 'Initiated' },
  { key: '进行中', value: 'Incomplete' },
  { key: '已完成', value: 'Complete' },
]

// 管理员 继续教育学习状态
export const educationStudyStatus = [
  { key: '学习未开始', value: 'Initiated' },
  { key: '学习进行中', value: 'Incomplete' },
  { key: '学习已完成', value: 'Complete' },
  { key: '学习未完成', value: 'Uncomplete' },
]
// 英语能力
export const EnglishAbility = [
  { key: '无英语能力', value: 'none' },
  { key: '简单英文能力（能够识别简单词汇）', value: 'simple' },
  { key: '基础英文能力（相当于大学英语四级水平）', value: 'basic' },
  { key: '较好的英文能力（相当于大学英语六级水平）', value: 'good' },
  { key: '优秀的英语能力（能够独立沟通协作）', value: 'best' },
  { key: '优秀的足球英文能力（能够就足球术语进行英文沟通）', value: 'very_best' },
]
// 运动能力
export const experienceNew = [
  { key: '国家一线队', value: '国家一线队' },
  { key: '顶级职业联赛（中超/女超/海外顶级联赛）', value: '顶级职业联赛（中超/女超/海外顶级联赛）' },
  { key: '第二级别联赛（中甲/女甲/海外次级别联赛）', value: '第二级别联赛（中甲/女甲/海外次级别联赛）' },
  { key: '五人制职业联赛（五超/女五）', value: '五人制职业联赛（五超/女五）' },
  { key: '第三级别联赛（中乙/女乙/海外第三级别联赛）', value: '第三级别联赛（中乙/女乙/海外第三级别联赛）' },
  { key: '五人制第二级别联赛（五甲）', value: '五人制第二级别联赛（五甲）' },
  { key: '全国性业余联赛（中冠联赛）', value: '全国性业余联赛（中冠联赛）' },
  { key: '地方性业余联赛（含大学生联赛）', value: '地方性业余联赛（含大学生联赛）' },
  { key: '全国性精英青少年比赛（职业俱乐部/会员协会/全运会）', value: '全国性精英青少年比赛（职业俱乐部/会员协会/全运会）' },
  { key: '地方性青少年比赛（社会青训机构）', value: '地方性青少年比赛（社会青训机构）' },
  { key: '校园足球比赛', value: '校园足球比赛' },
  { key: '其他', value: '其他' },
]

// 执教经历 算分的
export const coach_experience_new = [{
  value: 'U6',
  label: 'U6'
}, {
  value: 'U7',
  label: 'U7'
}, {
  value: 'U8',
  label: 'U8'
}, {
  value: 'U9',
  label: 'U9'
}, {
  value: 'U10',
  label: 'U10'
}, {
  value: 'U11',
  label: 'U11'
}, {
  value: 'U12',
  label: 'U12'
}, {
  value: 'U13',
  label: 'U13'
}, {
  value: 'U14',
  label: 'U14'
}, {
  value: 'U15（U16）',
  label: 'U15（U16）'
}, {
  value: 'U17（U18）',
  label: 'U17（U18）'
}, {
  value: 'U19（U20）',
  label: 'U19（U20）'
}, {
  value: 'U21（预备队/大学队）',
  label: 'U21（预备队/大学队）'
}, {
  value: '一线队',
  label: '一线队'
}];

export const coach_experience_new_children1 = [{
  value: '地方性青少年比赛（社会青训机构）',
  label: '地方性青少年比赛（社会青训机构）'
}, {
  value: '校园足球比赛',
  label: '校园足球比赛'
}];
export const coach_experience_new_children2 = [{
  value: '全国性精英青少年比赛（职业俱乐部/中国足协会员协会）',
  label: '全国性精英青少年比赛（职业俱乐部/中国足协会员协会）'
},{
  value: '地方性青少年比赛（社会青训机构）',
  label: '地方性青少年比赛（社会青训机构）'
},{
  value: '校园足球比赛',
  label: '校园足球比赛'
}];
export const coach_experience_new_children5 = [{
  value: '全国性精英青少年比赛（中青赛全国总决赛阶段/职业俱乐部/中国足协会员协会）',
  label: '全国性精英青少年比赛（中青赛全国总决赛阶段/职业俱乐部/中国足协会员协会）'
},{
  value: '地方性青少年比赛（中青赛预赛阶段/社会青训机构）',
  label: '地方性青少年比赛（中青赛预赛阶段/社会青训机构）'
},{
  value: '校园足球比赛',
  label: '校园足球比赛'
}];
export const coach_experience_new_children6 = [{
  value: '全国性精英青少年比赛（职业俱乐部青训比赛/中青赛全国总决赛阶段）',
  label: '全国性精英青少年比赛（职业俱乐部青训比赛/中青赛全国总决赛阶段）'
},{
  value: '地方性青少年比赛（中青赛预赛阶段/社会青训机构）',
  label: '地方性青少年比赛（中青赛预赛阶段/社会青训机构）'
},{
  value: '校园足球比赛',
  label: '校园足球比赛'
}];
export const coach_experience_new_children3 = [{
  value: '全国性精英青少年比赛（职业俱乐部青训比赛）',
  label: '全国性精英青少年比赛（职业俱乐部青训比赛）'
},{
  value: '校园足球比赛（含大学生联赛）',
  label: '校园足球比赛（含大学生联赛）'
}];
export const coach_experience_new_children4 = [{
  value: '国家队',
  label: '国家队'
},{
  value: '顶级职业联赛（中超/女超/海外顶级联赛）',
  label: '顶级职业联赛（中超/女超/海外顶级联赛）'
},{
  value: '第二级别联赛（中甲/女甲/海外次级别联赛）',
  label: '第二级别联赛（中甲/女甲/海外次级别联赛）'
},{
  value: '五人制职业联赛（五超/女五）',
  label: '五人制职业联赛（五超/女五）'
},{
  value: '第三级别联赛（中乙/女乙/海外第三级别联赛）',
  label: '第三级别联赛（中乙/女乙/海外第三级别联赛）'
},{
  value: '五人制第二级别联赛（五甲）',
  label: '五人制第二级别联赛（五甲）'
},{
  value: '全国性业余联赛（中冠联赛）',
  label: '全国性业余联赛（中冠联赛）'
},{
  value: '地方性业余联赛',
  label: '地方性业余联赛'
},{
  value: '其他',
  label: '其他'
}];
// 职务
export const coach_position_list = [{
  value: '主教练',
  label: '主教练'
},{
  value: '助理教练',
  label: '助理教练'
},{
  value: '守门员教练',
  label: '守门员教练'
},{
  value: '体能教练',
  label: '体能教练'
},{
  value: '技术分析',
  label: '技术分析'
},{
  value: '运动表现分析',
  label: '运动表现分析'
}];

// 行为投诉级别列表
export const feedback_complaint = [
  { key: "D级", value: "D" },
  { key: "C级", value: "C" },
  { key: "B级", value: "B" },
  { key: "A级", value: "A" },
  { key: "职业级", value: "PRO" },
  { key: "守门员C级", value: "GC" },
  { key: "体能L1级", value: "F1" },
  { key: "体能L2级", value: "F2" },
]

// 成绩申述级别列表
export const feedback_appeal = [
  { key: "B级", value: "B" },
  { key: "A级", value: "A" },
  { key: "职业级", value: "PRO" },
  { key: "体能L1级", value: "F1" },
  { key: "体能L2级", value: "F2" },
]
// 处罚人员状态
export const punish_people_status_list = [
  { label: '待审核', value: 'audit' },
  { label: '审核通过', value: 'pass' },
  { label: '审核拒绝', value: 'repulse' },
]
// 高水平球员认证类型
export const high_player_type_list = [
  { label: '150场以上顶级职业联赛出场经历', value: 'TopLeague' },
  { label: '国家一线队国际A级比赛出场经历', value: 'InternationalLeague' },
]
// 高水平球员认证类型
export const high_player_type_status = [
  { label: '待审核', value: 'audit' },
  { label: '通过', value: 'pass' },
  { label: '拒绝', value: 'refused' },
  { label: '继续完善', value: 'perfect' },
]
// 执教单位
export const take_unit_list = [
  { label: '国字号球队', value: '国字号球队' },
  { label: '中超联赛俱乐部', value: '中超联赛俱乐部' },
  { label: '女超联赛俱乐部', value: '女超联赛俱乐部' },
  { label: '中甲联赛俱乐部', value: '中甲联赛俱乐部' },
  { label: '女甲联赛俱乐部', value: '女甲联赛俱乐部' },
  { label: '中乙联赛俱乐部', value: '中乙联赛俱乐部' },
  { label: '女乙联赛俱乐部', value: '女乙联赛俱乐部' },
  { label: '顶级业余联赛俱乐部（中冠）', value: '顶级业余联赛俱乐部（中冠）' },
  { label: '业余联赛俱乐部', value: '业余联赛俱乐部' },
  { label: '五人制职业联赛俱乐部', value: '五人制职业联赛俱乐部' },
  { label: '海外职业俱乐部', value: '海外职业俱乐部' },
  { label: '海外业余俱乐部', value: '海外业余俱乐部' },
  { label: '体育局/中国足协会员协会（省级）/青训中心', value: '体育局/中国足协会员协会（省级）/青训中心' },
  { label: '地方会员协会', value: '地方会员协会' },
  { label: '高等院校', value: '高等院校' },
  { label: '高中/职高院校', value: '高中/职高院校' },
  { label: '初中学校', value: '初中学校' },
  { label: '小学学校', value: '小学学校' },
  { label: '社会青训机构', value: '社会青训机构' },
  { label: '其他', value: '其他' },
  { label: '未在执教', value: '未在执教' },
]
// 队伍年龄
export const team_age_list = [
  { label: 'U6', value: 'U6' },
  { label: 'U7', value: 'U7' },
  { label: 'U8', value: 'U8' },
  { label: 'U9', value: 'U9' },
  { label: 'U10', value: 'U10' },
  { label: 'U11', value: 'U11' },
  { label: 'U12', value: 'U12' },
  { label: 'U13', value: 'U13' },
  { label: 'U14', value: 'U14' },
  { label: 'U15（U16）', value: 'U15（U16）' },
  { label: 'U17（U18）', value: 'U17（U18）' },
  { label: 'U19（U20）', value: 'U19（U20）' },
  { label: 'U21（预备队/大学队）', value: 'U21（预备队/大学队）' },
  { label: '一线队', value: '一线队' }
]
// 队伍性别
export const take_job_list = [
  { label: '主教练', value: '主教练' },
  { label: '助理教练', value: '助理教练' },
  { label: '守门员教练', value: '守门员教练' },
  { label: '体能教练', value: '体能教练' },
  { label: '其他', value: '其他' },
]
export const coachExportTitle = [
  { key: "姓名", value: "name" },
  { key: "身份证号", value: "id_number" },
  { key: "手机号", value: "mobile_phone" },
  { key: "性别", value: "gender" },
  { key: "出生年月", value: "birthday" },
  { key: "注册协会", value: "org_abbreviation" },
  { key: "服装尺码", value: "track_suit" },
  { key: "教练员最高等级", value: "coachRankType" },
  { key: "守门员教练等级", value: "coachRankSpecialType" },
  { key: "体能教练等级", value: "coachRankPhysicalType" },
  { key: "等级执照到期时间", value: "coachLicenseEnd" },
  { key: "守门员执照到期时间", value: "coachGoalieLicenseEnd" },
  { key: "体能执照到期时间", value: "coachPhysicalLicenseEnd" },
  { key: "现执教单位", value: "take_unit_all" },
  { key: "单位名称", value: "take_unit_name" },
];
